import { Component } from '@angular/core';

@Component({
    selector: 'app-form-container-centered',
    templateUrl: './form-container-centered.component.html',
    styleUrls: ['./form-container-centered.component.scss']
})
export class FormContainerCenteredComponent {}
